// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskPricePreview-container {
  align-items: center;
  background: #f7f8fa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #667085;
  display: flex;
  font-size: 12px;
  gap: 6px;
  justify-content: space-between;
  margin: 8px 0;
  min-height: 34px;
  padding: 7px 9px;
}

.TaskPricePreview-container.is-success {
  background: #fff8e8;
  border-color: #f4d58a;
  color: #8a5a00;
}

.TaskPricePreview-container.is-success strong {
  color: #b54708;
  font-size: 14px;
}

.TaskPricePreview-container.is-success small {
  color: #9a6700;
  font-size: 10px;
  text-align: right;
}

.TaskPricePreview-container.is-error {
  background: #fff1f0;
  border-color: #ffccc7;
  color: #b42318;
}

.TaskPricePreview-spinner {
  animation: TaskPricePreview-spin 0.8s linear infinite;
  border: 2px solid #d0d5dd;
  border-radius: 50%;
  border-top-color: #667085;
  height: 12px;
  width: 12px;
}

@keyframes TaskPricePreview-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/TaskPricePreview.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".TaskPricePreview-container {\n  align-items: center;\n  background: #f7f8fa;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  color: #667085;\n  display: flex;\n  font-size: 12px;\n  gap: 6px;\n  justify-content: space-between;\n  margin: 8px 0;\n  min-height: 34px;\n  padding: 7px 9px;\n}\n\n.TaskPricePreview-container.is-success {\n  background: #fff8e8;\n  border-color: #f4d58a;\n  color: #8a5a00;\n}\n\n.TaskPricePreview-container.is-success strong {\n  color: #b54708;\n  font-size: 14px;\n}\n\n.TaskPricePreview-container.is-success small {\n  color: #9a6700;\n  font-size: 10px;\n  text-align: right;\n}\n\n.TaskPricePreview-container.is-error {\n  background: #fff1f0;\n  border-color: #ffccc7;\n  color: #b42318;\n}\n\n.TaskPricePreview-spinner {\n  animation: TaskPricePreview-spin 0.8s linear infinite;\n  border: 2px solid #d0d5dd;\n  border-radius: 50%;\n  border-top-color: #667085;\n  height: 12px;\n  width: 12px;\n}\n\n@keyframes TaskPricePreview-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
